import { Route } from "react-router";

import { HotelIDRootErrorBoundary } from "@/components/features/error-boundary";

import { DesignMagazineEditDefaultPage } from "@/components/pages/[hotelID]/reservationPage/magazine/edit/default/page";
import { DesignMagazineEditI18nPage } from "@/components/pages/[hotelID]/reservationPage/magazine/edit/i18n/page";
import { DesignSnackCreateNewItemPage } from "@/components/pages/[hotelID]/reservationPage/snack/create-new-item/page";
import { DesignSnackEditPage } from "@/components/pages/[hotelID]/reservationPage/snack/edit/page";

import { PATHS } from "../paths";

export const HotelRoute = (
	<Route errorElement={<HotelIDRootErrorBoundary />}>
		{/* HPB（ホームページビルダー） */}
		<Route
			path={PATHS.HOTEL.HPB.EDIT.NEW}
			index
			lazy={async () => {
				const res = await import("@/components/pages/[hotelID]/HPB/create-new-item/page");
				return {
					Component: res.DesignHPBCreateNewItemPage,
				};
			}}
		/>
		<Route
			path={PATHS.HOTEL.HPB.EDIT.UUID}
			index
			lazy={async () => {
				const res = await import("@/components/pages/[hotelID]/HPB/edit/page");
				return {
					Component: res.DesignHPBEditPage,
				};
			}}
		/>

		{/* スナック */}
		<Route path={PATHS.HOTEL.RESERVATION_PAGE.SNACK.EDIT.NEW} index element={<DesignSnackCreateNewItemPage />} />
		<Route path={PATHS.HOTEL.RESERVATION_PAGE.SNACK.EDIT.UUID} index element={<DesignSnackEditPage />} />

		{/* マガジン 編集 日本語 */}
		<Route
			path={PATHS.HOTEL.RESERVATION_PAGE.MAGAZINE.EDIT.DEFAULT}
			index
			element={<DesignMagazineEditDefaultPage />}
		/>
		{/* マガジン 編集 I18n */}
		<Route path={PATHS.HOTEL.RESERVATION_PAGE.MAGAZINE.EDIT.I18N} index element={<DesignMagazineEditI18nPage />} />
	</Route>
);
